module.exports = __webpack_public_path__ + "img/arrow7-l.edabcbc5.png";